import React from 'react';
import PropTypes from 'prop-types';

import './AnalyticsSection.css';

const AnalyticsSection = ({ children, className, header, row = false }) => (
  <>
    {row ?
      <div className={`analytics-section-row__component ${className}`}>
        {children}
      </div>
      :
      <div className={`analytics-section__component ${className}`}>
        {header &&
          <div className="analytics-section-header">
            {header}
          </div>
        }
        <div className="analytics-section-wrapper">
          {children}
        </div>
      </div>
    }
  </>
);

AnalyticsSection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.object, PropTypes.node]),
  // children: PropTypes.array,
  className: PropTypes.string,
  header: PropTypes.oneOfType([PropTypes.element]),
  row: PropTypes.bool,
};
AnalyticsSection.defaultProps = {
  children: null,
  className: '',
  header: null,
  row: false,
};

export default AnalyticsSection;
